<div class="d-flex flex-column on-screen-check-header mx-2">
	<app-pos-on-screen-check-header (checkSelectorChange)="checkSelectorChange.emit($event)"></app-pos-on-screen-check-header>
	<p-divider styleClass="my-2"></p-divider>
	<div *ngIf="posService.orderService.activeSeat.value?.items">
		<ng-container *ngFor="let item of posService.orderService.activeSeat.value.items">
			<app-pos-on-screen-check-items [checkItem]="item" (selectedItemChange)="onItemSelect($event)"></app-pos-on-screen-check-items>
		</ng-container>
	</div>
	<div class="align-bottom">
		<p-divider></p-divider>
	</div>
</div>
